export default "__VITE_ASSET__CmLg5W6e__"